import { uploadImage } from "@/helperFunctions/uploadImage";
import { useState } from "react";

const useImageUpload = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  const upload = async (file: File, location: string) => {
    setLoading(true);
    setError(null);
    setImageUrl(null);

    try {
      const url = await uploadImage(file, location);
      setImageUrl(url);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  return { upload, loading, error, imageUrl };
};

export default useImageUpload;
